/**
 * 基于wow.js封装的指令
 * v-wow="{
 *  name: 'fadeIn',
 *  delay: '2s',
 *  duration:'1s',
 *  offset: 100,
 *  iteration: 10
 * }"
 */
export default {
  install(Vue, options = {}) {
    Vue.directive('wow', {
      bind(el, binding) {
        if (!binding.value) return
        const { name, ...params } = binding.value
        el.classList.add('wow', name)
        Object.keys(params).forEach(k => {
          el.setAttribute(`data-wow-${k}`, params[k])
        })
      }
    })
  }
}

